var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 115,
    viewBox: "0 0 100 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.683 26.4133L52.9194 0.648749C52.1779 0.185357 51.1585 0 50.0463 0C48.9342 0 47.9147 0.278035 47.1733 0.648749L2.68767 26.506C1.11214 27.4328 0 29.7498 0 31.5107V83.1325C0 84.152 0.185357 85.3568 0.926784 86.3763L99.9073 28.9157C99.3512 27.8035 98.5171 26.9694 97.683 26.4133Z",
    fill: "#9B4F96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.648804 86.2838C1.1122 87.0253 1.76095 87.674 2.40969 88.0447L47.0807 113.902C47.8221 114.365 48.8416 114.551 49.9537 114.551C51.0659 114.551 52.0853 114.273 52.8267 113.902L97.3124 88.0447C98.8879 87.1179 100 84.801 100 83.0401V31.4182C100 30.5841 99.9074 29.6573 99.444 28.8232L0.648804 86.2838Z",
    fill: "#68217A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7868 68.4895C65.8943 75.3477 58.4801 79.9816 50.0463 79.9816C37.5347 79.9816 27.3401 69.787 27.3401 57.2754C27.3401 44.7639 37.5347 34.5692 50.0463 34.5692C58.4801 34.5692 65.8943 39.2032 69.7868 46.154L81.835 39.2032C75.5329 28.1744 63.67 20.6675 50.0463 20.6675C29.8424 20.6675 13.4384 37.0716 13.4384 57.2754C13.4384 77.4793 29.8424 93.8834 50.0463 93.8834C63.5774 93.8834 75.4402 86.4691 81.7423 75.5331L69.7868 68.4895ZM80.6302 59.3144L81.4643 55.3292H77.5718V50.9733H82.2984L83.4105 45.2273H87.9518L86.8396 50.8806H90.3614L91.4736 45.2273H95.9221L94.81 50.8806H97.0343V55.2365H93.9759L93.1418 59.2217H97.0343V63.5776H92.3077L91.1955 69.1383H86.6543L87.7664 63.5776H84.2446L83.1325 69.1383H78.6839L79.7961 63.5776H77.5718V59.2217H80.6302V59.3144ZM85.0788 59.3144H88.6005L89.4346 55.3292H85.9129L85.0788 59.3144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSharp);
export default __webpack_public_path__ + "static/media/CSharp.e70992f9ff964d206ebd78fd1705975c.svg";
export { ForwardRef as ReactComponent };